export const OPEN = 'open';
export const ERROR = 'error';
export const CLOSE = 'close';
export const MESSAGE = 'message';
